<header
    class="w-full h-[350px] md:h-[512px] relative shadow-lg"
    [ngStyle]="{
    backgroundImage: this.img,
    objectFit: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: page?.primaryAccentColor,
}">
    <div class="absolute top-0 left-0 w-full h-full bg-black/50 z-10 p-4 md:p-16">
        <div class="h-full w-full container mx-auto flex flex-col gap-1 md:gap-4 justify-center text-center">
            <span class="md:grow"></span>
            <h1 class="font-extrabold text-white text-2xl md:text-6xl lg:!text-8xl">
                Our job roles
            </h1>

            <span class="md:grow"></span>
            <form [formGroup]="searchForm" class="w-full md:w-1/2 mx-auto py-4 lg:p-6 text-left">
                <div class="flex flex-col md:flex-row gap-2">
                    <div class="w-full">
                        <label
                            for="keywordsInput"
                            class="text-sm font-light text-white leading-6"
                            i18n>Keywords</label
                        >
                        <div class="relative mt-1">
                            <button class="cursor-pointer absolute inset-y-0 right-0 flex items-center px-3 rounded-r-md" [ngStyle]="getAccentColourAsStyle('primaryAccentColor', 'background')" (click)="search()">
                                <svg
                                    class="h-5 w-5 text-white"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    aria-hidden="true"
                                    aria-label="Search icon">
                                    <path
                                        fill-rule="evenodd"
                                        d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z"
                                        clip-rule="evenodd" />
                                </svg>
                            </button>
                            <input
                                id="keywordsInput"
                                formControlName="keywords"
                                [ngStyle]="getAccentColourAsStyle('primaryAccentColor', 'border')"
                                class="block w-full h-10 p-2 rounded-md border border-gray-300 placeholder:text-gray-400 focus:border-2 focus:border-indigo-600 sm:text-sm sm:leading-6"
                                [ngClass]="{
                                    'text-gray-100': page?.darkMode,
                                    'text-gray-900': !page?.darkMode,
                                }" />
                        </div>
                    </div>
                </div>
                <div class="flex flex-col md:flex-row gap-2">
                    <div class="grow" *ngIf="searchMeta?.categories && component?.showFilters?.category !== false">
                        <label
                            for="categoryInput"
                            class="text-sm font-light leading-6 text-white"
                            i18n
                            >Category</label
                        >
                        <select
                            id="categoryInput"
                            formControlName="category"
                            [ngStyle]="getAccentColourAsStyle('primaryAccentColor', 'border')"
                            class="mt-1 block w-full h-10 p-2 pr-6 rounded-md border border-gray-300 focus:border-2 focus:border-indigo-600 sm:text-sm sm:leading-6 text-gray-900"
                           >
                            <option *ngFor="let term of searchMeta?.categories" [value]="term">{{ term }}</option>
                        </select>
                    </div>
                    <div class="grow" *ngIf="searchMeta?.locations && component?.showFilters?.locationLabel !== false">
                        <label
                            for="locationLabelInput"
                            class="text-sm font-light leading-6 text-white"
                            i18n
                            >Location</label
                        >
                        <select
                            id="locationLabelInput"
                            formControlName="locationLabel"
                            [ngStyle]="getAccentColourAsStyle('primaryAccentColor', 'border')"
                            class="mt-1 block w-full h-10 p-2 pr-6 rounded-md border border-gray-300 focus:border-2 focus:border-indigo-600 sm:text-sm sm:leading-6"
                            [ngClass]="{
                                'text-gray-100': page?.darkMode,
                                'text-gray-900': !page?.darkMode,
                            }">
                            <option value=""></option>
                            <option *ngFor="let term of searchMeta?.locations" [value]="term">{{ term }}</option>
                        </select>
                    </div>
                </div>
            </form>
        </div>
    </div>
</header>
